<template>
<div>
  <el-dialog :visible.sync="visible" :title="title" width="1000px" class="my-dialog-template" top="5vh" :close-on-click-modal="false">
    <el-form :inline="true" :model="formData" ref='formRef' class="my-form-template" label-width="90px" v-loading="loading">
      <el-form-item label="角色名称" prop="name" class="full" :rules="$tools.formRule.required('请输入')">
        <el-input v-model="formData.name" :disabled="look" placeholder="不超过12个字" maxlength="12" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="角色备注" prop="remark" class="full">
        <el-input v-model="formData.remark" :disabled="look" placeholder="备注" type="textarea" rows="4" maxlength="50" show-word-limit></el-input>
      </el-form-item>
      <div class="auth-box">
        <div class="auth-label">
          <span class="dian">*</span>
          <span class="text">权限</span>
          <span class="info-text">注意：此权限同时适用于PC管理后台和APP端</span>
        </div>
        <a-tree
          class="tree"
          v-model="checkedKeys"
          :treeData="treeData"
          :disabled="look"
          :checkable="true"
          default-expand-all
          :selectable="false"
          :replace-fields="{children: 'children',title: 'name',key:'id'}"
          @check="treeSelect"
        >
          <div slot="treeTitle" slot-scope="data">
            <span>{{data.name}}</span>
            <el-tooltip v-if="data.desc" popper-class="tree-tooltip" effect="dark" placement="top">
              <div slot="content" style="max-width:300px;text-align: left;">{{data.desc}}</div>
              <span class="icon-wenhao1 wenhao" @click.stop></span>
            </el-tooltip>
          </div>
        </a-tree>
      </div>
    </el-form>
    <div class="dialog-footer" v-if="!look">
      <el-button class="org-btn" plain @click="visible=false">取消</el-button>
      <el-button @click="save()">确定</el-button>
    </div>
  </el-dialog>
</div>
  
</template>
<script>
export default {
  data: () => ({
    visible: false,
    loading: false,
    look: false,//查看模式
    treeData:[],
    treeMap:{},
    keyMap:{},
    formData:{},
    checkedKeys:[],
    title:"",
  }),
  components: {},
  methods: {
    async open(data={},look=false) {
      if(look){
        this.title = "查看权限";
      }else if(data.id){
        this.title = "编辑角色";
      }else{
        this.title = "新增角色";
      }
      this.look = look;
      this.checkedKeys = [];
      this.formData = JSON.parse(JSON.stringify(data))
      const loading = this.$notice.loading();
      await this.getPermissionData(data.id);//获取所有权限菜单
      this.visible = true
      this.$refs.formRef&&this.$refs.formRef.clearValidate()
      loading.close();
    },
    //获取所有权限菜单
    getPermissionData(id){
      return this.$http({
        url:'/master/mechanRole/listPermissionMenu',
        type:'GET',
        params:{
          roleId:id
        },
      }).then(res=>{
        this.convertData(res.data)
        this.treeData = [{
          id:"-1",
          name:"全部",
          children:res.data
        }];
        console.log(this.treeData)
      })
    },
    // 转换树数据
    convertData(list){
      list.forEach(item=>{
        item.class = item.icon
        item.scopedSlots = { title: 'treeTitle' }
        if(item.children&&item.children.length){
          this.convertData(item.children)
        }else{
          this.treeMap[item.id] = item;//构造叶子节点map
          if(item.status==1){
            this.checkedKeys.push(item.id)
          }
          // 构造叶子节点内部对应关系
          if(item.relyId){
            if(this.keyMap[item.relyId]){
              this.keyMap[item.relyId].push(item.id);
            }else{
              this.keyMap[item.relyId] = [item.id];
            }
          }
        }
      })
    },
    // 树选择
    treeSelect(selectedKeys,e){
      const isSelect = e.checked;
      const data = e.node.dataRef;
      if(data.children&&data.children.length){//非叶子节点不处理
        return;
      }
      if(isSelect&&data.relyId){
        this.addSelectKey(data.relyId)
      }else if(!isSelect&&!data.relyId){
        this.delSelectKey(data.id)
      }
    },
    // 增加选中的key
    addSelectKey(key){
      if(!this.checkedKeys.includes(key)){
        this.checkedKeys.push(key)
      }
    },
    // 删除选中的key
    delSelectKey(key){
      if(this.keyMap[key]){//查找是否有对应关系
        const keys = this.keyMap[key];
        this.checkedKeys = this.checkedKeys.filter(k=>{
          return !keys.includes(k)
        })
      }
    },
    save() {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          if(this.checkedKeys.length==0){
            this.$message.error("请至少选择一个权限");
            return;
          }
          const userinfo = this.$tools.getLocal("userinfo");
          const params = JSON.parse(JSON.stringify(this.formData))
          params.moduleIds = this.checkedKeys.filter(id=>{
            if(id.includes(-1)){//自定义的“全部”节点过滤掉
              return false
            }
            if(!this.treeMap[id]){//非叶子节点过滤掉
              return false
            }
            return true;
          }).join(",");
          params.isSyncNewMenu = 0;
          params.mechanId = userinfo.mechanId;
          console.log(params)
          this.$http({
            url:'/master/mechanRole/save',
            type:'POST',
            params:params,
          }).then(res=>{
            this.$message.success("角色保存成功");
            this.$emit("reload")
            this.visible = false
          })
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
@import "./editForm.scss";
</style>